module.exports = __webpack_public_path__ + "img/comment-blue.5493098c.svg";